import { useAuth0 } from "@auth0/auth0-react"
import React, { useContext, useEffect, useMemo } from "react"
import { useLocation, useParams } from "react-router-dom"
import BifrostTab from "../../../../../Components/BifrostElementComponent/BifrostTab/BifrostTab"
import GroupDetailComponent from "../../../../../Components/BifrostPageComponent/GroupComponent/GroupDetailsComponent/GroupDetailsComponent"
import Loader from "../../../../../Components/BifrostPageComponent/Loader/Loader"
import { useGetGroupById } from "../../../../../Hooks/FetchHooks/GetDataService/useGetDataById/useGetGroupById"
import userInfoContext from "../../../../../store/userInfoContext"
import { hasFeatureInPackage, isSuperAdminOrResellerAdminOrAdmin } from "../../../../../Utils/util"
import Error401 from "../../../../OtherPages/ErrorPage/Error401"
import MainPanelFooter from "../../../MainPanelFooter/MainPanelFooter"
import MainPanelHeader from "../../../MainPanelHeader/MainPanelHeader"

const GroupDetailPage = () => {
	const { id } = useParams()
	const { state } = useLocation()
	const { user } = useAuth0()
	const userInfo = useContext(userInfoContext)
	const { isLoading, isError, data: group, getGroupById } = useGetGroupById(id)

	// todo here we should use dispatch to opreate the add and remove user and device from the group
	// and trigger the getGroupById to update the group details

	const detailData = useMemo(() => {
		return [
			{
				tabName: "Details",
				feature: null,
				featureName: null,
				featureIcon: null,
				renderCondition: null,
				disabled: false,
				tabContent: <GroupDetailComponent group={group} refreshData={getGroupById} />
			},
			{
				tabName: "Audit",
				feature: hasFeatureInPackage(userInfo, "audit_log"),
				featureName: "audit_log",
				featureIcon: "star outline",
				renderCondition: true, //TODO should be null or false when it is ready
				//TODO maybe later it should set as when it is true or null then it will display, otherwise it will not display
				disabled: !isSuperAdminOrResellerAdminOrAdmin(user),
				tabContent: "here should add the audit log of the group"
			},
			{
				tabName: "Sessions",
				feature: hasFeatureInPackage(userInfo, "statistics"),
				featureName: "statistics",
				featureIcon: null,
				renderCondition: true, //TODO should be null or false when it is ready
				disabled: !isSuperAdminOrResellerAdminOrAdmin(user),
				tabContent: "here should add the sessions of the group"
			}
		]
	})

	const style = useMemo(() => {
		return {
			tabular: true,
			tabStyle: { paddingTop: "10px" },
			contentStyle: { padding: "20px" }
		}
	})

	useEffect(() => {
		if (id) {
			getGroupById()
		}
	}, [id])

	return (
		<>
			<section className={"bifrost-table-panel devices-table"}>
				<MainPanelHeader title={isError ? " " : "Group"} name={state ? state.name : ""} navPath={"/groups"} />
				{isLoading ? (
					<Loader backgroundColor="white" inverted height="1px" minHeight="200px" />
				) : (
					<>{isError ? <Error401 backgroundColor="white" /> : <BifrostTab detailData={detailData} style={style} />}</>
				)}
				<MainPanelFooter />
			</section>
		</>
	)
}

export default GroupDetailPage
